import { entityErrorTypeName } from "src/business/error/entityErrorTypeName";
import {
  ZEntityError,
  ZEntityErrorType,
} from "src/business/error/ZEntityError";
import { buildOwners } from "src/components/MForm/formNav/buildOwners";
import { findDataNode } from "src/components/MForm/formNav/findDataNode";
import { MfError } from "src/components/MForm/MfError";
import { mfPath2str, str2MfPath } from "src/components/MForm/MFormTypes";
import { MfNode } from "src/components/MForm/node";

export type MfErrorRow = {
  id: string;
  type: ZEntityErrorType;
  typeName: string;
  attrName?: string;
  message: string;
  path?: string;
  displayPath?: string;
  warning?: boolean;
};

const mfDisplayPath2str = (owners?: MfNode[]) =>
  owners
    ?.filter(({ title }) => Boolean(title))
    .map(({ title }) => title)
    .join("/");

export const mfErrorToRow = (src: MfError, root: MfNode): MfErrorRow => {
  const owners = buildOwners(root, src.node.dataPath);
  const path = mfPath2str(src.node.dataPath);

  return {
    id: `@front:${path}`,
    path,
    displayPath: mfDisplayPath2str(owners),
    type: ZEntityErrorType.attr,
    typeName: entityErrorTypeName(ZEntityErrorType.attr),
    attrName: src.node.title,
    message: src.error.message,
  };
};

export const cvtEntityErrorToRow = (
  { type, attributePath, message, warning }: ZEntityError,
  root: MfNode,
): MfErrorRow => {
  let path: string | undefined;
  let displayPath: string | undefined;
  let attrName: string | undefined;

  if (attributePath) {
    const mPath = str2MfPath(attributePath);
    const node = findDataNode(root, mPath);
    if (node) {
      const owners = buildOwners(root, node.dataPath);

      path = mfPath2str(node.dataPath);
      displayPath = mfDisplayPath2str(owners);
      attrName = node.title;
    }
  }
  return {
    id: `${type}:${attributePath}:${message}`,
    type,
    typeName: entityErrorTypeName(type),
    message,
    path,
    displayPath,
    attrName,
    warning: warning ?? undefined,
  };
};
